import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  title: {
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
  },
  contentRoot: {
    padding: 0,
    minHeight: "300px",
    maxHeight: "500px",
  },
  viewBtn: {
    width: "50%",
  },
}))

export default styles
